<div class="row">
    <div class="col-md-12 loader">
        <div class="lds-facebook">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</div>